export default __webpack_public_path__ + "images/9e70d619db2521a1fba470a2af2a8434.png";